import { render, staticRenderFns } from "./BookingPositionJobandTalent.vue?vue&type=template&id=47b010ac&"
import script from "./BookingPositionJobandTalent.vue?vue&type=script&lang=js&"
export * from "./BookingPositionJobandTalent.vue?vue&type=script&lang=js&"
import style0 from "./BookingPositionJobandTalent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports